import { Quote } from 'lucide-react'
import { FC, PropsWithChildren } from 'react'
import { cn, TooltipWrapper } from '@wellesley/ui'

type TQuoteAction = {
  canRepost: boolean
}

export const RepostTooltipWrapper: FC<TQuoteAction & PropsWithChildren> = ({
  children,
  canRepost,
}) => (
  <TooltipWrapper
    theme="dark"
    size="small"
    tooltipText={
      canRepost ? '' : 'Only public posts can be reposted and quoted'
    }
    triggerProps={{
      asChild: true,
    }}
  >
    {children}
  </TooltipWrapper>
)

const QuoteAction: FC<TQuoteAction> = ({ canRepost }) => (
  <RepostTooltipWrapper canRepost={canRepost}>
    <div
      className={cn(
        'gap-xxs flex cursor-pointer flex-row text-base text-gray-700',
        {
          ['cursor-not-allowed opacity-50']: !canRepost,
        },
      )}
    >
      <Quote size={20} color="var(--gray-700)" />
      <span>Quote</span>
    </div>
  </RepostTooltipWrapper>
)

export default QuoteAction
